export const viewPurchaseHistoryProperties = (purchaseCount: number) => {
  return {
    pageTitle: 'Purchase history',
    purchaseCount,
  };
};
